import React from 'react'
import { Icon } from '@st-operations/uikit/src/v2'

import './styles.scss'
import classNames from 'classnames'

const ClosePanelButton = ({ className, onClose }) => {
  return (
    <button className={classNames('close-panel-button__btn', className)} onClick={onClose}>
      <Icon
        className="close-panel-button__btn-icon"
        icon="angleleft"
        width={24}
        height={24}
        color="currentColor"
        type="outline"
      />
    </button>
  )
}

export default ClosePanelButton
